let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("17Qwb"), load("dWaws"), load("fPlzG")]).then(() => parcelRequire('3kK7t'));